import { FixedProductInputSchema,
  PlanInputFormUsageProductSchema,
  PlanInputSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const PlanInputFormSchema = oz
  .object(PlanInputSchema.shape)
  .omit({
    products: true,
  })
  .extend({
    fixedProducts: oz.array(FixedProductInputSchema),
    usageProducts: oz.array(PlanInputFormUsageProductSchema),
  })
  .partial()
  .refine(data => (data?.fixedProducts?.length ?? 0) > 0 || (data?.usageProducts?.length ?? 0) > 0, {
    message: 'Plan must have at least one product',
    path: ['productsValidation'],
  });

export type PlanInputForm = oz.infer<typeof PlanInputFormSchema>;